module.exports = __webpack_public_path__ + "static/media/toolsLogo.208e5754.png";